import { CheckOutlined } from "@ant-design/icons";
import { notification } from "antd";
import { FC } from "react";
import { Market } from "tm-shared/types";

import { MarketCard } from "@/components/MarketCard";
import {
    StyledUMMarketCard,
    StyledUMMarketInfo,
    StyledUMMarketList,
    StyledUMSelectionBadge,
} from "@/pages/WorkPlan/Tasks/UnplannedMarkets/Styled";

interface MarketListProps {
    markets: Market[];
    selectedMarkets: Market[];
    onToggleSelection: (market: Market) => void;
    marketExtraIds: string[];
}

export const MarketList: FC<MarketListProps> = ({
    markets,
    selectedMarkets,
    onToggleSelection,
    marketExtraIds,
}) => (
    <StyledUMMarketList>
        {markets.map((market) => {
            const isDisabled = marketExtraIds.includes(market.id);
            const isSelected = selectedMarkets.some((m) => m.id === market.id);

            const handleClick = () => {
                if (isDisabled) {
                    notification.error({
                        message: `Торгова точка "${market.name}" вже в маршруті`,
                    });
                    return;
                }
                onToggleSelection(market);
            };

            return (
                <StyledUMMarketCard
                    key={market.id}
                    onClick={handleClick}
                    hasDuty={market.hasDebt}
                    isDisabled={isDisabled}
                    isSelected={isSelected}
                >
                    {isSelected && (
                        <StyledUMSelectionBadge>
                            <CheckOutlined />
                        </StyledUMSelectionBadge>
                    )}
                    <StyledUMMarketInfo isDisabled={isDisabled}>
                        <MarketCard
                            address={market.address.name}
                            fop={market.contragent.name}
                        />
                    </StyledUMMarketInfo>
                </StyledUMMarketCard>
            );
        })}
    </StyledUMMarketList>
);
